<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 财务概览卡片 -->
    <!-- <div class="bg-gradient-to-r from-blue-500 to-purple-600 text-white p-6 mb-4">
      <h2 class="text-lg font-semibold mb-4">财务概览</h2>
      <div class="grid grid-cols-2 gap-4">
        <div class="bg-white bg-opacity-20 rounded-lg p-3">
          <p class="text-sm opacity-90">本月应收</p>
          <p class="text-xl font-bold">¥{{ overview.monthlyReceivable.toLocaleString() }}</p>
          <div class="flex items-center mt-1">
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
            </svg>
            <span class="text-sm">净应收: ¥{{ overview.netReceivable.toLocaleString() }}</span>
          </div>
        </div>
        <div class="bg-white bg-opacity-20 rounded-lg p-3">
          <p class="text-sm opacity-90">本月应付</p>
          <p class="text-xl font-bold">¥{{ overview.monthlyPayable.toLocaleString() }}</p>
          <div class="flex items-center mt-1">
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
            <span class="text-sm">净应付: ¥{{ overview.netPayable.toLocaleString() }}</span>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-4">
        <div class="bg-white bg-opacity-20 rounded-lg p-3">
          <p class="text-sm opacity-90">本月销售</p>
          <p class="text-xl font-bold">¥{{ overview.monthlySales.toLocaleString() }}</p>
          <div class="flex items-center mt-1">
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
            </svg>
            <span class="text-sm">{{ overview.salesOrderCount }}单</span>
          </div>
        </div>
        <div class="bg-white bg-opacity-20 rounded-lg p-3">
          <p class="text-sm opacity-90">本月进货</p>
          <p class="text-xl font-bold">¥{{ overview.monthlyPurchase.toLocaleString() }}</p>
          <div class="flex items-center mt-1">
            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
            </svg>
            <span class="text-sm">{{ overview.purchaseOrderCount }}单</span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 快捷操作 -->
    <div class="bg-white p-4 mb-4 shadow-sm">
      <h3 class="text-lg font-semibold text-gray-900 mb-3">快捷操作</h3>
      <div class="grid grid-cols-2 gap-3">
        <button
          @click="$router.push('/mobile/finance/report')"
          class="bg-blue-500 text-white rounded-lg p-4 flex items-center justify-center space-x-2 hover:bg-blue-600 transition-colors"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <span>财务报表</span>
        </button>
        
        <button
          @click="$router.push('/mobile/finance/cashflow')"
          class="bg-green-500 text-white rounded-lg p-4 flex items-center justify-center space-x-2 hover:bg-green-600 transition-colors"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
          </svg>
          <span>资金流水</span>
        </button>
        
        <button
          @click="$router.push('/mobile/finance/receivable')"
          class="bg-orange-500 text-white rounded-lg p-4 flex items-center justify-center space-x-2 hover:bg-orange-600 transition-colors"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <span>应收账款</span>
        </button>
        
        <button
          @click="$router.push('/mobile/finance/payable')"
          class="bg-red-500 text-white rounded-lg p-4 flex items-center justify-center space-x-2 hover:bg-red-600 transition-colors"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
          <span>应付账款</span>
        </button>
      </div>
    </div>

    <!-- 收付款快捷操作 -->
    <div class="bg-white p-4 mb-4 shadow-sm">
      <h3 class="text-lg font-semibold text-gray-900 mb-3">收付款管理</h3>
      <div class="grid grid-cols-2 gap-3">
        <!-- 收款单快捷操作 -->
        <div class="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
          <div class="flex items-center justify-between mb-3">
            <div class="bg-green-500 p-2 rounded-lg">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
              </svg>
            </div>
            <span class="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full font-medium">收款</span>
          </div>
          <div class="space-y-2">
            <button @click="handleCreateReceipt" class="w-full bg-green-500 text-white py-2 px-3 rounded-lg text-sm font-medium hover:bg-green-600 transition-colors">
              新建收款单
            </button>
            <button @click="handleViewReceiptList" class="w-full bg-white border border-green-300 text-green-700 py-2 px-3 rounded-lg text-sm font-medium hover:bg-green-50 transition-colors">
              收款单列表
            </button>
          </div>
        </div>

        <!-- 付款单快捷操作 -->
        <div class="bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4">
          <div class="flex items-center justify-between mb-3">
            <div class="bg-blue-500 p-2 rounded-lg">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <span class="text-xs text-blue-600 bg-blue-100 px-2 py-1 rounded-full font-medium">付款</span>
          </div>
          <div class="space-y-2">
            <button @click="handleCreatePayment" class="w-full bg-blue-500 text-white py-2 px-3 rounded-lg text-sm font-medium hover:bg-blue-600 transition-colors">
              新建付款单
            </button>
            <button @click="handleViewPaymentList" class="w-full bg-white border border-blue-300 text-blue-700 py-2 px-3 rounded-lg text-sm font-medium hover:bg-blue-50 transition-colors">
              付款单列表
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 最近交易 -->
    <div class="bg-white p-4 mb-4 shadow-sm">
      <h3 class="text-lg font-semibold text-gray-900 mb-3">核销单管理</h3>
      <div class="bg-gradient-to-br from-indigo-50 to-blue-50 border border-indigo-200 rounded-lg p-4">
        <div class="flex items-center justify-between mb-3">
          <div class="bg-indigo-500 p-2 rounded-lg">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14l2 2 4-4M7 7h10M7 11h6m-8 9h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <span class="text-xs text-indigo-600 bg-indigo-100 px-2 py-1 rounded-full font-medium">核销</span>
        </div>
        <div class="grid grid-cols-2 gap-3">
          <button @click="$router.push('/mobile/finance/writeoff/add')" class="w-full bg-indigo-500 text-white py-2 px-3 rounded-lg text-sm font-medium hover:bg-indigo-600 transition-colors">
            新建核销单
          </button>
          <button @click="$router.push('/mobile/finance/writeoff/list')" class="w-full bg-white border border-indigo-300 text-indigo-700 py-2 px-3 rounded-lg text-sm font-medium hover:bg-indigo-50 transition-colors">
            核销单列表
          </button>
        </div>
      </div>
    </div>

    <div class="bg-white p-4 mb-4 shadow-sm">
      <div class="flex items-center justify-between mb-3">
        <h3 class="text-lg font-semibold text-gray-900">最近交易</h3>
        <button
          @click="$router.push('/mobile/finance/transactions')"
          class="text-blue-500 text-sm hover:text-blue-600 transition-colors"
        >
          查看全部
        </button>
      </div>
      
      <div class="space-y-3">
        <div
          v-for="transaction in recentTransactions"
          :key="transaction.id"
          class="flex items-center justify-between p-3 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <div class="flex items-center space-x-3">
            <div :class="[
              'w-10 h-10 rounded-full flex items-center justify-center'
            ]">
              <svg class="w-5 h-5" :class="transaction.type === 'income' ? 'text-green-600' : 'text-red-600'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path v-if="transaction.type === 'income'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18" />
                <path v-else stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
            <div>
              <p class="font-medium text-gray-900">{{ transaction.description }}</p>
              <p class="text-sm text-gray-500">{{ transaction.category }} · {{ transaction.date }}</p>
            </div>
          </div>
          <div class="text-right">
            <p :class="[
              'font-semibold',
              transaction.type === 'income' ? 'text-green-600' : 'text-red-600'
            ]">
              {{ transaction.type === 'income' ? '+' : '-' }}¥{{ transaction.amount.toLocaleString() }}
            </p>
            <p class="text-xs text-gray-500">{{ transaction.account }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { companyFinanceApi, financeReportApi } from '@/api/api'
import dayjs from 'dayjs'

const router = useRouter()

const selectedPeriod = ref('7d')

const overview = ref({
  monthlyReceivable: 0,
  netReceivable: 0,
  monthlyPayable: 0,
  netPayable: 0,
  monthlySales: 0,
  salesOrderCount: 0,
  monthlyPurchase: 0,
  purchaseOrderCount: 0
})



const chartData = ref([])



const recentTransactions = ref([])

// 计算日期范围
const computeDateRange = () => {
  const map = { '7d': 7, '30d': 30, '90d': 90 }
  const days = map[selectedPeriod.value] || 7
  const endDate = dayjs().format('YYYY-MM-DD')
  const startDate = dayjs().subtract(days - 1, 'day').format('YYYY-MM-DD')
  return { startDate, endDate, days }
}

// 概览：应收、应付、销售、进货
const loadOverview = async () => {
  try {
    // 并行获取四个接口的数据
    const [receivableRes, payableRes, salesRes, purchaseRes] = await Promise.all([
      financeReportApi.getMonthlyReceivable(),
      financeReportApi.getMonthlyPayable(),
      financeReportApi.getMonthlySales(),
      financeReportApi.getMonthlyPurchase()
    ])

    // 处理应收数据
    if (receivableRes?.success && receivableRes.data) {
      overview.value.monthlyReceivable = Number(receivableRes.data.monthlyIncrease || 0)
      overview.value.netReceivable = Number(receivableRes.data.netReceivable || 0)
    }

    // 处理应付数据
    if (payableRes?.success && payableRes.data) {
      overview.value.monthlyPayable = Number(payableRes.data.monthlyIncrease || 0)
      overview.value.netPayable = Number(payableRes.data.netPayable || 0)
    }

    // 处理销售数据
    if (salesRes?.success && salesRes.data) {
      overview.value.monthlySales = Number(salesRes.data.totalSales || 0)
      overview.value.salesOrderCount = Number(salesRes.data.orderCount || 0)
    }

    // 处理进货数据
    if (purchaseRes?.success && purchaseRes.data) {
      overview.value.monthlyPurchase = Number(purchaseRes.data.totalPurchase || 0)
      overview.value.purchaseOrderCount = Number(purchaseRes.data.orderCount || 0)
    }
  } catch (e) {
    console.error('获取财务概览数据失败', e)
    // 设置默认值
    overview.value = {
      monthlyReceivable: 0,
      netReceivable: 0,
      monthlyPayable: 0,
      netPayable: 0,
      monthlySales: 0,
      salesOrderCount: 0,
      monthlyPurchase: 0,
      purchaseOrderCount: 0
    }
  }
}

// 映射资金流水为交易卡片
const mapFlowToTransaction = (item) => {
  const type = item.flowTypeName === '收入' || item.flowType === 1 ? 'income' : 'expense'
  return {
    id: item.id,
    type,
    description: item.businessTypeName || item.remarks || '资金流水',
    category: item.accountName || '',
    amount: Number(item.amount || 0),
    date: item.createdOn ? dayjs(item.createdOn).format('YYYY-MM-DD HH:mm') : '',
    account: item.businessNo || ''
  }
}

// 最近交易（取前4条）
const loadRecentTransactions = async () => {
  const { startDate, endDate } = computeDateRange()
  try {
    const params = {
      pagination: { current: 1, pageSize: 10 },
      search: { flowNo: '', accountName: '', flowType: '', businessType: '', startDate, endDate },
      sort: { predicate: 'createdOn', reverse: true }
    }
    const res = await companyFinanceApi.getFundFlowList(params)
    if (res?.success && res.data) {
      const list = Array.isArray(res.data.list) ? res.data.list.map(mapFlowToTransaction) : []
      recentTransactions.value = list.slice(0, 4)
    }
  } catch (e) {
    console.error('获取最近交易失败', e)
  }
}

// 收支趋势（按日汇总）
const loadChartData = async () => {
  const { startDate, endDate, days } = computeDateRange()
  try {
    // 拉取较大页尺寸以覆盖期间数据
    const params = {
      pagination: { current: 1, pageSize: 500 },
      search: { flowNo: '', accountName: '', flowType: '', businessType: '', startDate, endDate },
      sort: { predicate: 'createdOn', reverse: true }
    }
    const res = await companyFinanceApi.getFundFlowList(params)
    const list = (res?.success && res.data?.list) ? res.data.list : []

    // 先构造连续日期标签
     const labels = []
     for (let i = days - 1; i >= 0; i--) {
       labels.push(dayjs().subtract(i, 'day').format('MM-DD'))
     }
     const buckets = labels.reduce((acc, label) => { acc[label] = { income: 0, expense: 0 }; return acc }, {})

     list.forEach(it => {
       const d = it.createdOn ? dayjs(it.createdOn).format('MM-DD') : null
       if (!d || !(d in buckets)) return
       const amt = Number(it.amount || 0)
       const isIncome = it.flowTypeName === '收入' || it.flowType === 1
       if (isIncome) buckets[d].income += amt
       else buckets[d].expense += amt
     })

     chartData.value = labels.map(label => ({ label, income: buckets[label].income, expense: buckets[label].expense }))
   } catch (e) {
     console.error('获取趋势数据失败', e)
     chartData.value = []
   }
 }

 
 
 

 // 收付款快捷操作处理函数
 const handleCreateReceipt = () => {
   router.push('/mobile/finance/receipt/add')
 }

 const handleViewReceiptList = () => {
   router.push('/mobile/finance/receipt/list')
 }

 const handleCreatePayment = () => {
   router.push('/mobile/finance/payment/add')
 }

 const handleViewPaymentList = () => {
   router.push('/mobile/finance/payment/list')
 }
 
 onMounted(async () => {
   await Promise.all([loadOverview(), loadChartData(), loadRecentTransactions()])
 })

 watch(selectedPeriod, async () => {
   await Promise.all([loadOverview(), loadChartData(), loadRecentTransactions()])
 })
</script>

<style scoped>
/* 图表动画 */
.transition-all {
  transition: all 0.3s ease-in-out;
}

/* 渐变背景（使用主题色） */
.bg-gradient-to-r {
  background: linear-gradient(to right, var(--primary-500), var(--primary-700));
}

/* 卡片悬停效果 */
.hover\:bg-gray-50:hover,
.hover\:bg-gray-100:hover {
  transition: background-color 0.2s ease-in-out;
}
</style>
